import { useQuery } from '@tanstack/react-query';

import { useCurrentScope } from '../../../shared/scope/useCurrentScope.js';
import {
  getProjectById,
  getProjectDetailQueryKey,
  getProjectsQueryKey,
  listProjects,
  type ListProjectsFilters,
} from '../api/projects.client.js';

export function useProjects(filters: ListProjectsFilters = {}) {
  const scope = useCurrentScope();
  const workspaceId = scope?.workspaceId ?? 'anonymous';
  return useQuery({
    queryKey: getProjectsQueryKey(workspaceId, filters),
    queryFn: () => listProjects(filters),
    enabled: scope !== null,
  });
}

export function useProject(projectId: string) {
  const scope = useCurrentScope();
  const workspaceId = scope?.workspaceId ?? 'anonymous';
  return useQuery({
    queryKey: getProjectDetailQueryKey(workspaceId, projectId),
    queryFn: () => getProjectById(projectId),
    enabled: scope !== null && projectId.length > 0,
  });
}
